import EditablePropsType from '../../../types/composer';
import headingSchema from './heading';

export const rowsSchema = {
  type: EditablePropsType.Array,
  label: 'Rows',
  name: 'rows',
  items: {
    type: EditablePropsType.Object,
    properties: {
      heading: headingSchema,
      subheading: {
        type: EditablePropsType.RichText,
        name: 'subheading',
        label: 'Subheading',
      },
      image: {
        type: EditablePropsType.Object,
        label: 'Image',
        name: 'image',
        properties: {
          src: {
            type: EditablePropsType.Media,
            name: 'src',
            label: 'Image Source',
            accept: ['image/*'],
          },
          altText: {
            type: EditablePropsType.Text,
            name: 'altText',
            label: 'Alt Text',
          },
        },
      },
      enabledColumns: {
        type: EditablePropsType.Array,
        name: 'enabledColumns',
        label: 'Enabled Columns',
        items: {
          type: EditablePropsType.Text,
        },
      },
    },
  },
};
export default rowsSchema;
